import { Navigate, Outlet } from "react-router-dom";

const STORAGE_KEY = "growing-student-user";

/**
 * localStorage에서 사용자 정보를 확인하여 로그인 상태 판단
 * (httpOnly 쿠키는 JavaScript로 읽을 수 없으므로 localStorage 사용)
 */
function isLoggedIn(): boolean {
  try {
    const userJson = localStorage.getItem(STORAGE_KEY);
    return !!userJson;
  } catch {
    return false;
  }
}

/**
 * 인증이 필요한 라우트를 보호하는 컴포넌트
 * 인증되지 않은 사용자는 로그인 페이지로 리다이렉트됨
 */
export function ProtectedRoute() {
  if (!isLoggedIn()) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Outlet />;
}
